"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPrimaryText = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _BaseTextObject = _interopRequireDefault(require("../BaseTextObject"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledPrimaryText = (0, _styledComponents.default)(_BaseTextObject.default).withConfig({
  displayName: "PrimaryTextstyles__StyledPrimaryText",
  componentId: "sc-1e18csl-0"
})(["&,& *{font-size:", ";", ";}"], function (props) {
  return props.theme.fontMediumSmall;
}, function (props) {
  return props.fullWidth ? undefined : "max-width: ".concat(props.theme.componentSizeLarge);
});
exports.StyledPrimaryText = StyledPrimaryText;